import {observable} from "mobx";
import {MobXHelper} from "common-import/helpers";
import api from "./Rating.API";

const { makePersit } = MobXHelper;

class RatingStore {
  @observable listRating = [];

  getList = async ({objectId}) => {
    const res = await api.list({objectId});
    if (!!res.validateError) {
      return { error: res.validateError };
    }
    return await res.json();
  };

  create = async (data) => {
    const res = await api.create(data);
    if (!!res.validateError) {
      return {error: res.validateError};
    }
    return await res.json();
  };

  update = async (data) => {
    const res = await api.update(data);
    if (!!res.validateError) {
      return {error: res.validateError};
    }
    return await res.json();
  };

  delete = async (data) => {
    const res = await api.delete(data);
    if (!!res.validateError) {
      return {error: res.validateError};
    }
    return await res.json();
  };
}

const ratingStore = new RatingStore();
export default ratingStore;



// WEBPACK FOOTER //
// ./src/services/rating/Rating.Store.js